<script>
import { toPercent, toMoney } from '@utils/Format'
import { FONT_FAMILY } from '@constants/Styles'
import { donutChartColors } from '@constants/Color'

export default {
  props: {
    /**
     * formato:{grupos: {name(string),percent(number),color(string)}}
     */
    values: Object,
    size: {
      type: Number,
      default: 0,
    },
    centerText: {
      type: Boolean,
      default: false,
    },
    chartShowMoney: {
      type: Boolean,
      default: false,
    },
    showNegative: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toMoney,
      toPercent,
      chartOpts: {
        legend: false,
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          y: {
            formatter: (value) => {
              return this.chartShowMoney ? toMoney(value) : toPercent(value)
            },
          },
        },
        labels: [],
        plotOptions: {
          pie: {
            donut: {
              size: '80%',
              labels: {
                show: true,
                name: {
                  fontSize: '12px',
                  fontFamily: FONT_FAMILY,
                  color: '#2D212F',
                  offsetY: -15,
                },
                value: {
                  fontSize: '12px',
                  fontFamily: FONT_FAMILY,
                  offsetY: -15,
                  formatter: (v) => {
                    return this.chartShowMoney ? toMoney(v) : toPercent(v)
                  },
                },
                total: {
                  fontSize: '12px',
                  fontFamily: FONT_FAMILY,
                  show: true,
                  formatter: (w) => {
                    return this.chartShowMoney
                      ? toMoney(
                          w.globals.seriesTotals.reduce((a, b) => {
                            return a + b
                          }, 0)
                        )
                      : toPercent(
                          w.globals.seriesTotals.reduce((a, b) => {
                            return a + b
                          }, 0)
                        )
                  },
                },
              },
            },
          },
        },
      },
    }
  },
  computed: {
    lista() {
      return Object.values(this.values)
        .sort((a, b) => {
          return b.percent - a.percent
        })
        .filter((item) => {
          return item.percent > 0 || this.showNegative
        })
    },
    formatOpts() {
      return {
        ...this.chartOpts,
        labels: this.lista.map((item) => {
          return item.name
        }),
        colors: this.lista.map((item, index) => {
          return item.color || donutChartColors[index % donutChartColors.length]
        }),
      }
    },
    formatData() {
      return this.lista.map((item) => {
        return this.chartShowMoney ? item.value : item.percent
      })
    },
  },
}
</script>

<template>
  <div
    class="d-flex justify-content-center"
    :class="{ 'align-items-center': centerText }"
  >
    <!-- style="min-width: 25%; max-width:  50%;" -->
    <div
      style="width: 50%;"
      class="d-flex align-items-center justify-content-center"
    >
      <apexchart
        v-if="size"
        type="donut"
        :height="size"
        :width="size"
        :options="formatOpts"
        :series="formatData"
      >
      </apexchart>
      <apexchart
        v-if="!size"
        type="donut"
        :options="formatOpts"
        :series="formatData"
      >
      </apexchart>
    </div>
    <div
      class="d-flex flex-column"
      :class="{ 'justify-content-center': centerText }"
    >
      <!-- style="width: 50%;" -->
      <v-simple-table
        dense
        style="background: transparent; width: 100%;"
        class="tabela-composition"
      >
        <template>
          <tbody>
            <template v-for="c in lista">
              <tr v-if="c.percent > 0" :key="c.name" class="mb-1">
                <td>
                  <div class="d-flex align-items-center">
                    <v-sheet
                      height="20"
                      width="5"
                      :style="{ 'background-color': c.color }"
                    ></v-sheet>
                    <p class="ml-1 mr-5 mb-0">
                      {{ c.name }}
                    </p>
                  </div>
                </td>
                <td>
                  <p class="text-bold mb-0 mr-2 text-right">
                    {{ toPercent(c.percent) }}
                  </p>
                </td>
                <!-- <td v-if="chartShowMoney">
                  <p class="mb-0" style="white-space: nowrap;">
                    <small> ({{ toMoney(c.value) }}) </small>
                  </p>
                </td> -->
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<style lang="sass" scope>
.tabela-composition
  tr td
    border: none !important
    padding: 0 !important
    text-align: left !important
    // white-space: nowrap
</style>
